module.exports = __webpack_public_path__ + "img/higgs_module_1_img1.fe91ee52.gif";